import { render, staticRenderFns } from "./DocumentTasksModal.vue?vue&type=template&id=1ef67bbe&"
import script from "./DocumentTasksModal.vue?vue&type=script&lang=js&"
export * from "./DocumentTasksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports